/**
 * Registers the service worker, and applies a new version when one appears.
 *
 * An installed PWA can run for weeks without a reload, so a deploy would
 * otherwise sit unapplied behind the old worker.
 */
export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;
  if (import.meta.env.DEV) return;

  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { type: "module" }).then((registration) => {
      registration.addEventListener("updatefound", () => {
        const next = registration.installing;
        if (!next) return;
        next.addEventListener("statechange", () => {
          // A waiting worker with a controller present means an update is ready
          // and an older version is still serving this page.
          if (next.state === "installed" && navigator.serviceWorker.controller) {
            // ServiceWorker.postMessage takes no targetOrigin; that argument
            // belongs to window.postMessage, which this is not.
            // oxlint-disable-next-line unicorn/require-post-message-target-origin
            next.postMessage({ type: "skip-waiting" });
          }
        });
      });
    });
  });

  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
}
